export default "__VITE_ASSET__COHimf7a__"